/* istanbul ignore file */
export * from './EcoLabelList';
